import React from 'react';
import {List, ListItemProps} from '@mantine/core';

export const EtroListItem: React.FC<ListItemProps> = props => {
  return <List.Item {...props} />;
};
